// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b5a9ae0e","885":"5812a33f"}[chunkId] + ".chunk.js";
};